import { Component, inject, input, output } from '@angular/core';
import { DialogService } from '@shared/component.dialog';
import { VideoPlayerComponent } from '@shared/components/video-player/video-player.component';
import { PromoObject } from '@usecase/content/get-content.interface';

@Component({
  selector: 'world-cup-banner',
  standalone: true,
  imports: [],
  templateUrl: './world-cup-banner.component.html',
  styleUrl: './world-cup-banner.component.scss'
})
export class WorldCupBannerComponent {
  data = input<PromoObject>();

  // Output untuk komunikasi dengan parent component
  promoInteraction = output<{action: string, label?: string}>();

  readonly dialog = inject(DialogService);

  playVideo() {
    // Track video play interaction
    this.promoInteraction.emit({
      action: 'play_video',
      label: 'World Cup Banner Video'
    });

    this.dialog.open(VideoPlayerComponent, {
      data: {
        videoUrl: this.data()?.video_url
      },
      backdropClose: true
    });
  }
}
